import CloseIcon from '@mui/icons-material/Close';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { Dialog, IconButton } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../Button';

interface AgeVerificationDialogProps {
  open: boolean;
  onClose: () => void;
  onCancel: () => void;
  onConfirm: () => void;
}

const AgeVerificationDialog: React.FC<AgeVerificationDialogProps> = ({ open, onClose, onCancel, onConfirm }) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      disableEscapeKeyDown
      sx={{ '& .MuiPaper-root': { borderRadius: '12px', width: '100%', maxWidth: '360px', margin: '16px' } }}
    >
      <div className="p-4 flex flex-col gap-4 w-full" onClick={(event: React.MouseEvent<HTMLDivElement>) => event.stopPropagation()}>
        <div className="flex items-center justify-between gap-3">
          <p className="text-black-900 text-lg font-semibold leading-7 whitespace-pre-line">{t('AGE_VERIFICATION_TITLE')}</p>
          <IconButton onClick={onClose} size="small" sx={{ padding: '2px' }} aria-label="close">
            <CloseIcon sx={{ width: 24, height: 24, color: '#667085' }} />
          </IconButton>
        </div>
        <div className="flex justify-center">
          <div className="w-12 h-12 rounded-full bg-[#FEF3F2] flex items-center justify-center">
            <div className="w-8 h-8 rounded-full bg-[#FEE4E2] flex items-center justify-center">
              <WarningAmberIcon sx={{ width: 20, height: 20, color: '#F04438' }} />
            </div>
          </div>
        </div>
        <p className="text-gray-600 text-sm leading-5 whitespace-pre-line">{t('AGE_VERIFICATION_MESSAGE')}</p>
        <div className="flex flex-col gap-3">
          <Button type="secondary" onClick={onConfirm}>
            {t('AGE_VERIFICATION_CONFIRM')}
          </Button>
          <Button type="light" onClick={onCancel}>
            {t('AGE_VERIFICATION_CANCEL')}
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export default AgeVerificationDialog;
